"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
exports.ANALYTICS_CLIENTS = new core_1.InjectionToken('ANALYTICS_CLIENTS');
